<template>
  <div>
    <v-card class="no-shadow">
      <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
        <v-toolbar-title aling="center"
          ><v-icon>mdi-card-text-outline</v-icon> Gestion de Almacenamiento</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <template>
          <v-btn class="btn-principal" @click="mostrarDialogo">
            <v-icon>mdi-plus</v-icon>
            Crear nueva Carpeta
          </v-btn>
        </template>
      </v-toolbar>
      
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
        class="mb-4"
      ></v-text-field>
        <v-breadcrumbs divider="/" class="pt-1 cursor">
            <v-breadcrumbs-item
              @click.native="goDirectory(item.id)"
              v-for="item in listaPosicionDirectorios"
              :key="item.id"
            >
              <template v-if="item.text !== 'Mi Unidad'">
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              {{ item.text }}
            </v-breadcrumbs-item>
          </v-breadcrumbs>
      <v-data-table
        :headers="headers"
        :items="datos"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:item.icon="{ item }">
              <v-icon v-if="item.detail == 'Directorio'" @click="changePartent(item)">{{item.icon}}</v-icon>
              <v-icon v-else>{{item.icon}}</v-icon>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="getColor(item.estado)" dark>
            {{ item.estado }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="viewItem(item)">
            mdi-eye
          </v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          No hay items
        </template>
      </v-data-table>
    </v-card>
       <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >¿Estás seguro que deseas eliminar este ticket?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Volver</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >Eliminar</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="crateEditVer" max-width="500px">
          <createTickets :titulo="tituloDialogo" :disabledTicket="disabledTicket" :dataTicket="dataTicket"  v-on:recibeTickect="recibeTickect"/>
        </v-dialog>
  </div>
  
</template>
<script>
import axios from "axios";
import swal from "sweetalert";
import api from "../../conf/ruta-base";
import store from "../../store";
import UserProfile from "../../data";
import createTickets from "../tickets/create-tickets.vue";

export default {
  components: {
    createTickets,
  },
  data: () => ({
    parent: '/', // /Administracion/Pagos/Enero
    fileTypes: {
        'application/pdf': 'mdi-file-pdf',
        'image/png': 'mdi-file-image',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'mdi-file-excel'
    },
    user: UserProfile.getUserData(),
    dataTicket: null,
    disabledTicket: false,
    search: "",
    tituloDialogo: "Nuevo ticket",
    dialog: false,
    crateEditVer: false,
    dialogDelete: false,
    headers: [
    { text: "", value: "icon" },
      {
        text: "Nombre",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Detalles", value: "detail" },
      { text: "Elementos", value: "elements" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    datos: [],
    editedIndex: -1,
    editedItem: {
      titulo: "",
      tipo: "",
      lugar: "",
      parametrosLugar: "",
      tipoPlanificacion: "",
      tipoCreador: "",
      tipoServicio: "",
      grupoTarea: "",
      // descripcion: "",
      asignado_a: "",
      // estado: "",
      // creado_por: "",
    },
    listaPosicionDirectorios: [
        {
          text: "Mi Unidad",
          disabled: false,
          id: null
        },
    ],
  }),
  mounted() {
   this.location()
  },
  computed: {
    formTitle() {
      // this.editedItem.creado_por = this.user.user;

      return this.editedIndex === -1 ? "Nuevo ticket" : "Editar ticket";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    location(){
    this.datos = []
    //Consultamos las carpetas que esten a la altura del directorio
    let filter = {
        where: {
            parent: this.parent
        }
    } 
    axios.get(`${api.api}directorys?filter=${JSON.stringify(filter)}`)
        .then(res => {
            res.data.forEach(folder=>{
                this.datos.push({
                    icon: 'mdi-folder',
                    name: folder.name,
                    detail: 'Directorio',
                    elements: folder.objects,
                    parent: folder.parent,
                    id: folder.id
                })
            })
        })
    //Fin directorios
    //Consultamos los archivos
    filter = {
        where: {
            directory: this.parent
        }
    } 
    axios.get(`${api.api}files?filter=${JSON.stringify(filter)}`)
        .then(res => {
            res.data.forEach(files=>{
                this.datos.push({
                    icon: this.fileTypes[files.type] || 'mdi-file',
                    name: files.localName,
                    detail: 'Archivo',
                    elements: 1
                })
            })
        })
    //Fin archivos
    },
    goDirectory(imtes) {
    if(imtes === null && this.parent != '/'){
        this.parent = '/'
        this.listaPosicionDirectorios = [{
          text: "Mi Unidad",
          disabled: false,
          id: null
        }]
        this.location()
        return null
    }
    let bandera = true
    let parent = ''
    const newLista = [] 
    this.listaPosicionDirectorios.forEach(elemento => {
        if(bandera){
            newLista.push(elemento)
            parent = elemento.id != null ? parent + elemento.text : '/'
        }
        if(elemento.id == imtes) bandera = false
    })
    this.listaPosicionDirectorios = newLista
    this.parent = parent
    this.location()
    },
    recibeTickect(item){
      console.log("estoy aqui", item);
            this.crateEditVer = false;

            if(item !== undefined)this.tickets.push(item);

    },
    changePartent(item){
        if(!item.parent) return null
        this.listaPosicionDirectorios.push({text:item.name, disabled: false, id: item.id})
        this.parent = item.parent + item.name
        this.location()
    },
    mostrarDialogo() {
      this.crateEditVer = true;
            this.disabledTicket = false;
            this.dataTicket = {};

    },

    initialize() {
      this.tickets = [
        {
          titulo: "Título del ticket",
          tipo: "Capacitación",
          lugar: "Instalación",
          parametrosLugar: ["Piso", "Zona/Área"],
          tipoPlanificacion: "Programado",
          tipoCreador: "Cliente administrador",
          tipoServicio: "Aseo tradicional",
          grupoTarea: "Fin de semana",
          // descripcion: "",
          asignado_a: "Persona",
          // estado: "",
          // creado_por: this.user.user,
        },
      ];
    },
    getColor(estado) {
      if (estado == "No leído") return "default";
      else if (estado == "Resuelto") return "green";
      else if (estado == "Abierto") return "orange";
      else if (estado == "Cerrado") return "red";
    },

    editItem(item) {
      this.editedIndex = this.tickets.indexOf(item);
      this.editedItem = item;
      this.dialog = true;
      console.log(item);
this.dataTicket = item;
          this.tituloDialogo = "Editar ticket",
      this.crateEditVer = true;
      this.disabledTicket = false;

    },

    deleteItem(item) {
      this.editedIndex = this.tickets.indexOf(item);
      this.dialogDelete = true;

    },

    viewItem(item) {
      this.editedIndex = this.tickets.indexOf(item);
      this.editedItem = item;
          this.tituloDialogo = "Ver ticket",
      this.crateEditVer = true;
        this.dataTicket = item;
        this.disabledTicket = true;
      console.log("se vio");
    },

    deleteItemConfirm() {
      this.tickets.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.tickets[this.editedIndex], this.editedItem);
      } else {
        this.tickets.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>

<style lang="scss">
.combo-parametros {
  .v-select__selections {
    min-height: 56px !important;
  }
}
.theme--dark.v-chip.default {
  background: #f1f1f1;
  color: rgba(0, 0, 0, 0.87);
}
.v-text-field__details {
  display: none;
}
</style>
